import { ace } from '@axo/shared/data-access/types';
import { MarketCountryCode } from '@axo/shared/types';

export const callsKeys = {
  root: () =>
    ({
      service: 'ace',
      scope: 'calls',
    }) as const,
  orders: ({
    LoanApplicationID,
    CustomerPhoneNumber,
  }: Partial<ace.FindCallOrderRequest>) =>
    ({
      ...callsKeys.root(),
      entity: 'orders',
      LoanApplicationID,
      CustomerPhoneNumber,
    }) as const,
  records: ({
    LoanApplicationID,
    CustomerPhoneNumber,
  }: ace.FindCallRecordsRequest) =>
    ({
      ...callsKeys.root(),
      entity: 'records',
      LoanApplicationID,
      CustomerPhoneNumber,
    }) as const,
  tags: (marketCountry?: MarketCountryCode, userRoles?: string[]) =>
    ({
      ...callsKeys.root(),
      entity: 'tags',
      marketCountry,
      userRoles,
    }) as const,
};
